import { render } from "./TabNav.vue?vue&type=template&id=dbf60e44&scoped=true&ts=true"
import script from "./TabNav.vue?vue&type=script&lang=ts"
export * from "./TabNav.vue?vue&type=script&lang=ts"

import "./TabNav.vue?vue&type=style&index=0&id=dbf60e44&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbf60e44"]])

export default __exports__